export default "__VITE_ASSET__DKEPZauR__"